// Camera key helpers

export const toQueryCam = (key) => (key === "41" ? "41" : String(key || "").toLowerCase());
